function validateNumber(num, min, max){
    if(isNaN(num)){
        return min;
    }
    num = Math.round(num);
    return Math.min(max, Math.max(min, num));
}
export const jointRotateConfig = [
    {//向左旋转
        key: "0",
        min: 0,//最大旋转角度
        max: 359,//最小旋转角度
        optionLabel: "%{BKY_NUWA_TEXT_TURN_TO_LEFT}",
        label: "%{BKY_NUWA_TEXT_TO_LEFT}",
        suffix: "%{BKY_NUWA_TEXT_TURN}",
        speed: [0.193, 0.29, 0.39],
        apiName: "NuwaTurn",
        fixInputValue: function(value){
            return validateNumber(value, 0, 359);
        }
    },
    {//向右旋转
        key: "1",
        min: 0,//最大旋转角度
        max: 359,//最小旋转角度
        optionLabel: "%{BKY_NUWA_TEXT_TURN_TO_RIGHT}",
        label: "%{BKY_NUWA_TEXT_TO_RIGHT}",
        suffix: "%{BKY_NUWA_TEXT_TURN}",
        speed: [0.193, 0.29, 0.39],
        apiName: "NuwaTurn",
        fixInputValue: function(value){
            return validateNumber(value, 0, 359);
        }
    },
    {//前进
        key: "2",
        min: 0,
        max: 127,
        optionLabel: "%{BKY_NUWA_TEXT_MOVE_FORWARD}",
        label: "%{BKY_NUWA_TEXT_TO_FORWARD}",
        suffix: "%{BKY_NUWA_TEXT_MOVE}",
        speed: [5, 10, 20],
        apiName: "NuwaDriveward",
        fixInputValue: function(value){
            return validateNumber(value, 0, 127);
        }
    },
    {//后退
        key: "3",
        min: 0,
        max: 127,
        optionLabel: "%{BKY_NUWA_TEXT_MOVE_BACKWARD}",
        label: "%{BKY_NUWA_TEXT_TO_BACKEND}",
        suffix: "%{BKY_NUWA_TEXT_MOVE}",
        speed: [5, 10, 20],
        apiName: "NuwaDriveward",
        fixInputValue: function(value){
            return validateNumber(value, 0, 127);
        }
    },
    {//頭部垂直
        key: "-1,-1",
        min: -20,//最大旋转角度
        max: 20,//最小旋转角度
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_1}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_1}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_1}",
        apiName: "NuwaMove",
        speed: [0.12, 0.2, 0.3],
        fixInputValue: function(value){
            return validateNumber(value, -20, 20);
        }
    },
    {//头部左右
        key: "-1,2",
        min: -30,
        max: 30,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_2}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_2}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_1}",
        speed: [0.12, 0.2, 0.3],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            return validateNumber(value, -30, 30);
        }
    },
    {//左肩內轉
        key: "7,-1",
        min: 0,
        max: 90,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_3}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_3}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_2}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            return validateNumber(value, 0, 90);
        }
    },
    {//左肩上抬
        key: "8,-1",
        min: 0,
        max: 255,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION4}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_3_1}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_3}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            value = Number(value);
            return validateNumber(value + 55, 0, 255);
        }
    },
    {//左臂侧抬
        key: "9,1",
        min: -90,
        max: 0,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_5}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_4}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_4}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            value = Number(value);
            return validateNumber(-value, -90, 0);
        }
    },
    {//左手肘上抬
        key: "10,-1",
        min: 0,
        max: 75,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_6}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_5}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_3}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            return validateNumber(value, 0, 75);
        }
    },
    {//右肩侧抬
        key: "3,-1",
        min: 0,
        max: 90,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_7}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_6}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_2}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            return validateNumber(value, 0, 90);
        }
    },
    {//右肩上抬
        key: "4,-1",
        min: 0,
        max: 255,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_8}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_6_1}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_3}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            value = Number(value);
            return validateNumber(value + 55, 0, 255);
        }
    },
   {//右手臂侧抬
        key: "5,1",
        min: -90,
        max: 0,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_9}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_7}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_4}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            value = Number(value);
            return validateNumber(-value, -90, 0);
        }
    },
    {//右手肘上抬
        key: "6,-1",
        min: 0,
        max: 75,
        optionLabel: "%{BKY_NUWA_JOINT_ROTATE_OPTION_10}",
        label: "%{BKY_NUWA_JOINT_ROTATE_LABEL_8}",
        suffix: "%{BKY_NUWA_JOINT_ROTATE_SUFFIX_3}",
        speed: [0.12, 0.3, 0.5],
        apiName: "NuwaMove",
        fixInputValue: function(value){
            return validateNumber(value, 0, 75);
        }
    }
];
export function getSpeedValueByIndex(jointId, index){
    index = Number(index);
    let jointConfig = jointRotateConfig.find(item => item.key === jointId);
    let speedArr = new Array(3).fill(0);
    if(jointConfig){
        speedArr = jointConfig.speed;
    }
    return speedArr[index] || speedArr[1];
}
export function getSpeedIndexByValue(jointId, value){
    value = Number(value);
    let jointConfig = jointRotateConfig.find(item => item.key === jointId);
    let speedArr = new Array(3).fill(0);
    if(jointConfig){
        speedArr = jointConfig.speed;
    }
    let index = speedArr.findIndex(item => item === value);
    if(index === -1){
        index = 1;
    }
    return index;
}